/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import ReactGA from "react-ga4";
import { Button, Card, Space } from "antd";
import { IProductCard } from "interfaces/ClientInterface/IProduct";
import { useDispatch } from "react-redux";
import { setSelectedProductRedux, setProductTitle } from "store/slices/product.slice";
import { createCaptureDesign } from "api/services/product.api";
import ProductImage from "../ProductImage";
import ProductTitle from "../ProductTitle";
import uuid from "react-uuid";
import "./ProductCard.scss";

const ProductCard: React.FC<IProductCard> = ({
  key,
  imageUrl,
  titleText,
  setShowArifi,
  product,
  setSelectedProduct,
}: IProductCard) => {
  const dispatch = useDispatch();

  const onCreateNew = (product: any) => {
    ReactGA.event({
      category: "create_new_design",
      action: "Create new button clicked",
      label: "Create new button clicked"
    });
    if (localStorage.getItem("UserRecord") === null) {
      localStorage.setItem("isLoggedInUser", "false");
    } else {
      localStorage.setItem("isLoggedInUser", "true");
    }
    localStorage.setItem("selectedProduct", product.Name);
    dispatch(setProductTitle(titleText));
    dispatch(setSelectedProductRedux(product));
    setSelectedProduct && setSelectedProduct(product);
    onOpenConfigurations(product);
  };

  const getCode = (code: string): string[] => {
    if (code === "Helmet") {
      return ["helmets", "rawlings"];
    }
    if (code === "RawlingsGlove") {
      return ["gloves", "rawlings"];
    }
    if (code === "EastonGlove") {
      return ["gloves", "easton"];
    }
    if (code === "EastonHelmet") {
      return ["helmets", "easton"];
    }
    if (code === "WoodBat") {
      return ["woodbats", "rawlings"];
    }
    return [];
  };

  const openConfigurationWindow = async ([product, domain]: string[]): Promise<void> => {
    try {
      if (product && domain) {
        const guid: string = uuid();
        const isGuidCreated = await createCaptureDesign(guid);
        if (
          isGuidCreated &&
          isGuidCreated?.status === 200 &&
          isGuidCreated?.data?.IsSuccess &&
          !isGuidCreated?.data?.HasError
        ) {
          const configUrl = process.env.REACT_APP_THIRD_PARTY_CONFIGURATION;
          const openConfig = configUrl?.replace("<product>", product).replace("<domain>", domain);
          window.open(`${openConfig}?guid=${guid}`, "_self");
        }
      }
    } catch (error: any) {
      throw new Error(error?.message);
    }
  };

  const onOpenConfigurations = (product: any) => {
    const configurationTypeObject = product?.Attributes?.find(
      (attribute: { AttributeCode: string }) => attribute.AttributeCode === "ConfigurationType"
    );

    const isArtifi = configurationTypeObject?.SelectValues?.find(
      (value: { Code: string }) => value.Code === "Artifi"
    );
    if (isArtifi) setShowArifi && setShowArifi(true);

    const helmet = configurationTypeObject?.SelectValues?.find(
      (value: { Code: string }) => value.Code === "Helmet"
    );

    const rawlingsGlove = configurationTypeObject?.SelectValues?.find(
      (value: { Code: string }) => value.Code === "RawlingsGlove"
    );

    const eastonGlove = configurationTypeObject?.SelectValues?.find(
      (value: { Code: string }) => value.Code === "EastonGlove"
    );

    const eastonHelmet = configurationTypeObject?.SelectValues?.find(
      (value: { Code: string }) => value.Code === "EastonHelmet"
    );

    const woodBat = configurationTypeObject?.SelectValues?.find(
      (value: { Code: string }) => value.Code === "WoodBat"
    );

    localStorage.setItem("SKU", product?.SKU);

    if (helmet) openConfigurationWindow(getCode(helmet?.Code));
    if (rawlingsGlove) openConfigurationWindow(getCode(rawlingsGlove?.Code));
    if (eastonGlove) openConfigurationWindow(getCode(eastonGlove?.Code));
    if (eastonHelmet) openConfigurationWindow(getCode(eastonHelmet?.Code));
    if (woodBat) openConfigurationWindow(getCode(woodBat?.Code));
  };

  return (
    <Card className="product-grid create-configuration-image" key={key}>
      <Space direction={"vertical"} size={"small"} className="product-card">
        <div className="product-image">
          <ProductImage
            imageUrl={imageUrl}
            imageHeight="100%"
            imageWidth="auto"
            isPreview={false}
            className="product-image"
            alt="altTextProductImage"
          />
        </div>
        <div className="product-name">
          <ProductTitle
            titleClass="product-name create-configuration m-0"
            titleText={titleText}
            textFontLevel={5}
          />
        </div>
        <div className="product-grid-action">
          <Button
            type="primary"
            className="create-new-btn"
            data-test-selector={"btnCreateNew"}
            onClick={() => onCreateNew(product)}
          >
            Create New
          </Button>
        </div>
      </Space>
    </Card>
  );
};

export default ProductCard;
